import * as React from 'react';

const StorePickupRounded: React.FC = () => {
    return (
		<svg focusable="false" width="64" height="64" viewBox="42 42 60 60" xmlns="http://www.w3.org/2000/svg">
			<path fillRule="evenodd" clipRule="evenodd" d="M101.19 70.78c0 15.61-12.65 28.27-28.27 28.27-15.61 0-28.27-12.65-28.27-28.27 0-15.61 12.65-28.27 28.27-28.27 15.61 0 28.27 12.66 28.27 28.27" fill="currentColor"/>
			<path fillRule="evenodd" clipRule="evenodd" d="m88.33 66.02-3.53-7.06a1.99 1.99 0 0 0-1.79-1.1H62.82c-.76 0-1.45.42-1.79 1.1l-3.53 7.06c-.49.99-.09 2.19.89 2.68.28.14.58.21.89.21h.21v12.21a2.59 2.59 0 0 0 2.59 2.59h11.24a2.59 2.59 0 0 0 2.59-2.59V68.91h7.91v14.08c0 .4.33.73.73.73s.73-.33.73-.73V68.91h1.23a2 2 0 0 0 1.79-2.89m-27.36 9.67v-6.78h13.51v6.78" fill="#fff"/>
		</svg>
	);
};

export default React.memo(StorePickupRounded);
